module.exports = __webpack_public_path__ + "img/copy_circle_white.8be10f3f.png";